import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Enterprise } from 'models/Enterprises';

import './EnterpriseHeader.styles.scss';
import './EnterpriseHeader.styles.responsive.scss';

type EnterpriseHeaderProps = {
  className?: string;
  enterprise: Partial<Enterprise>;
};

const EnterpriseHeader: React.FC<EnterpriseHeaderProps> = (props) => {
  const { className, enterprise } = props;

  const { brandName } = enterprise;

  const classes = classNames('enterprise-header', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <h1>{t('enterpriseNameDashboard', { brandName })}</h1>
    </div>
  );
};

export default EnterpriseHeader;
